<template>
  <thead class="item sort">
    <th></th>
    <th v-for="item in 3" :key="item">
      <v-skeleton-loader type="text" />
    </th>
    <th></th>
  </thead>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
thead {
  padding: 0px 8px;
  th {
    border-bottom: 1px solid map-get($gray, lighten2);
    padding: 6px 16px;

    height: 52px;
    &:first-child {
      display: none;
    }
    &:nth-child(3) {
      width: 176px;
    }

    .v-skeleton-loader {
      max-width: 62px;
    }
  }
}
</style>